import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const FAQS = [
    {
        q: "Para quem a SETH trabalha?",
        a: "Para pequenos negócios que querem uma presença digital mais profissional e estratégica: hotéis, pousadas, chalés, restaurantes, clínicas, salões, academias, lojas, prestadores de serviços e pequenos negócios em geral.",
    },
    {
        q: "A SETH atende empresas de qualquer cidade?",
        a: "Sim. O diagnóstico, a estratégia e a entrega das soluções são realizados de forma digital, o que permite atender negócios de qualquer cidade.",
    },
    {
        q: "Preciso já ter Instagram?",
        a: "Não necessariamente. A SETH analisa o que o seu negócio já possui hoje e define o que precisa ser ajustado ou estruturado para melhorar a sua presença digital.",
    },
    {
        q: "A SETH cria meu conteúdo?",
        a: "Sim. No SETH ESSENCIAL™ estão incluídos 8 posts personalizados e 2 Reels, além de toda a organização da sua presença digital.",
    },
    {
        q: "O que está incluído no SETH ESSENCIAL™?",
        a: "Diagnóstico estratégico, auditoria de Instagram, auditoria de WhatsApp, ajuste de bio, organização dos destaques, configuração do WhatsApp Business, catálogo, mensagem de boas-vindas, 8 posts personalizados e 2 Reels — com entrega em até 7 dias úteis.",
    },
    {
        q: "O que é o SETH +RESERVAS™?",
        a: "É uma solução desenvolvida especialmente para hotéis, pousadas e chalés. Ela estrutura a comunicação e os principais pontos de contato com o hóspede — Instagram, WhatsApp, site e atendimento — e inclui o Manual Comercial para Hotelaria.",
    },
    {
        q: "Quanto tempo leva para receber a entrega?",
        a: "As soluções SETH ESSENCIAL™ e SETH +RESERVAS™ têm entrega em até 7 dias úteis.",
    },
    {
        q: "Como funciona o atendimento?",
        a: "O contato começa pelo WhatsApp. Você conversa com a SETH sobre o seu negócio e descobre qual solução faz mais sentido para o seu momento.",
    },
    {
        q: "Posso contratar apenas uma solução?",
        a: "Sim. Você pode escolher a solução que faz mais sentido para o momento do seu negócio.",
    },
];

const Faq = () => {
    const [open, setOpen] = useState(0);

    return (
        <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 scroll-mt-16">
            <div className="mx-auto max-w-3xl px-5 sm:px-8">
                <SectionHeading
                    align="center"
                    eyebrow="FAQ"
                    title={
                        <>
                            Perguntas <span className="text-gold-grad">frequentes</span>
                        </>
                    }
                />

                <div className="mt-14 border-t border-line">
                    {FAQS.map((item, i) => {
                        const isOpen = open === i;
                        return (
                            <Reveal key={item.q} delay={0.03 * i}>
                                <div className="border-b border-line">
                                    <button
                                        type="button"
                                        data-testid={`faq-trigger-${i + 1}`}
                                        aria-expanded={isOpen}
                                        onClick={() => setOpen(isOpen ? -1 : i)}
                                        className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                                    >
                                        <span
                                            className={`font-display text-base sm:text-lg font-semibold transition-colors duration-300 ${
                                                isOpen ? "text-gold" : "text-ink group-hover:text-gold"
                                            }`}
                                        >
                                            {item.q}
                                        </span>
                                        <span
                                            className={`w-8 h-8 min-w-[32px] rounded-full border flex items-center justify-center transition-all duration-300 ${
                                                isOpen
                                                    ? "border-gold/60 bg-gold/10 text-gold rotate-45"
                                                    : "border-line text-ink3 group-hover:border-gold/50 group-hover:text-gold"
                                            }`}
                                        >
                                            <Plus size={14} />
                                        </span>
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                                                className="overflow-hidden"
                                            >
                                                <p
                                                    data-testid={`faq-answer-${i + 1}`}
                                                    className="pb-7 pr-12 text-sm sm:text-[15px] text-ink2 leading-relaxed"
                                                >
                                                    {item.a}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Faq;
